/**
 * Contrato Taskeo API: `roleValue` / `companyRoleValue` (número ou string "1"|"2"|"3")
 * alinhados a `UserRole`; preferir a `role` string quando ambos existem.
 */
export const TASKEO_COMPANY_ROLE_VALUE_KEYS = [
  'companyRoleValue',
  'CompanyRoleValue',
  'roleValue',
  'RoleValue',
] as const;

type JsonRecord = Record<string, unknown>;

/** Primeiro valor numérico ou string numérica encontrado em qualquer um dos objetos. */
export function pickFirstCompanyRoleValueFromRecords(sources: JsonRecord[]): unknown {
  for (const source of sources) {
    if (!source || !Object.keys(source).length) continue;
    for (const key of TASKEO_COMPANY_ROLE_VALUE_KEYS) {
      const v = source[key];
      if (v === undefined || v === null) continue;
      if (typeof v === 'number' && Number.isFinite(v)) return v;
      if (typeof v === 'string' && v.trim()) return v.trim();
    }
  }
  return undefined;
}

/** `UserRole`: 1 Owner, 2 Admin, 3 Member — número, string, enum JSON .NET `{ "value": 2 }`. */
export function parseTaskeoUserRoleValue123(raw: unknown): number | undefined {
  if (raw === undefined || raw === null) return undefined;
  if (typeof raw === 'number' && Number.isFinite(raw)) {
    const n = Math.trunc(raw);
    if (n >= 1 && n <= 3) return n;
    return undefined;
  }
  if (typeof raw === 'string') {
    const t = raw.trim();
    if (/^[123]$/.test(t)) return parseInt(t, 10);
    const asInt = parseInt(t, 10);
    if (asInt >= 1 && asInt <= 3 && String(asInt) === t) return asInt;
  }
  if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
    const o = raw as Record<string, unknown>;
    const nested =
      o['value'] ??
      o['Value'] ??
      o['roleValue'] ??
      o['RoleValue'] ??
      o['companyRoleValue'] ??
      o['CompanyRoleValue'];
    if (nested !== undefined && nested !== raw) return parseTaskeoUserRoleValue123(nested);
  }
  return undefined;
}
